import {
  Container,
  Dialog as MUIDialog,
  DialogProps as MUIDialogProps,
  Stack,
} from "@mui/material";

import { DialogBar } from "./DialogBar";

export interface DialogProps extends MUIDialogProps {
  close: () => void;
}

export const Dialog: React.FC<DialogProps> = ({
  children,
  close,
  ...props
}) => {
  return (
    <MUIDialog {...props}>
      <Container
        sx={(theme) => ({
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
          pb: {
            xs: `calc(env(safe-area-inset-bottom) + ${theme.spacing(2)})`,
            md: `calc(env(safe-area-inset-bottom) + ${theme.spacing(4)})`,
          },
          pt: {
            xs: `calc(env(safe-area-inset-top) + ${theme.spacing(2)})`,
            md: `calc(env(safe-area-inset-top) + ${theme.spacing(4)})`,
          },
          px: 2,
        })}
      >
        <DialogBar onClose={close} />
        <Stack spacing={{ xs: 4, md: 6 }} flexGrow={1} alignItems="center">
          {children}
        </Stack>
      </Container>
    </MUIDialog>
  );
};
